import React from 'react';

export default () => <p className="address">
	PTMD Collection<br />
	Pietseweg 13A<br />
	4751 RT Oud Gastel NL
</p>;
